var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-date-picker", {
            staticClass: "filter-item",
            staticStyle: { width: "300px" },
            attrs: {
              clearable: "",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              "range-separator": "至",
              type: "daterange",
              "value-format": "yyyy-MM-dd"
            },
            model: {
              value: _vm.searchData.time,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "time", $$v)
              },
              expression: "searchData.time"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.onClickSearch }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-refresh" },
              on: { click: _vm.onClickReset }
            },
            [_vm._v("重置")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "success", icon: "el-icon-plus" },
              on: {
                click: function($event) {
                  _vm.showAdd = true
                }
              }
            },
            [_vm._v("新增")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            stripe: "",
            "highlight-current-row": "",
            border: ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "50" }
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumns, function(item, index) {
            return [
              _c("el-table-column", {
                key: index,
                attrs: {
                  label: item.label,
                  formatter: item.formatter,
                  prop: item.prop
                }
              })
            ]
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "230" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.updateItem(scope.row)
                          }
                        }
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.delItem(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "warning", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.offItem(scope.row)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(scope.row.releaseTag == 0 ? "发布" : "下架")
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total > 0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showAdd,
            title: _vm.recForm.id ? "编辑" : "新增",
            width: "500px",
            center: "",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showAdd = $event
            },
            close: _vm.onDialogClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "versionForm",
              attrs: {
                model: _vm.recForm,
                rules: _vm.recFormRule,
                "label-width": "140px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "中心板最低版本号",
                    required: "",
                    prop: "centerLowestVersion"
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      placeholder: "中心板最低版本",
                      clearable: ""
                    },
                    model: {
                      value: _vm.recForm.centerLowestVersion,
                      callback: function($$v) {
                        _vm.$set(_vm.recForm, "centerLowestVersion", $$v)
                      },
                      expression: "recForm.centerLowestVersion"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "程序指令", required: "", prop: "command" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "程序指令"
                      },
                      model: {
                        value: _vm.recForm.command,
                        callback: function($$v) {
                          _vm.$set(_vm.recForm, "command", $$v)
                        },
                        expression: "recForm.command"
                      }
                    },
                    [
                      _c("el-option", { attrs: { label: "1", value: 1 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "2", value: 2 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "3", value: 3 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "4", value: 4 } })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "弹窗时间段", required: "", prop: "time" } },
                [
                  _c("el-date-picker", {
                    staticClass: "filter-item",
                    staticStyle: { width: "300px" },
                    attrs: {
                      clearable: "",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      "range-separator": "至",
                      type: "daterange",
                      "value-format": "yyyy-MM-dd"
                    },
                    on: { change: _vm.onTimeChange },
                    model: {
                      value: _vm.recForm.time,
                      callback: function($$v) {
                        _vm.$set(_vm.recForm, "time", $$v)
                      },
                      expression: "recForm.time"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "弹窗文案", requird: "", prop: "content" } },
                [
                  _c("el-input", {
                    attrs: {
                      rows: "4",
                      placeholder: "弹窗文案",
                      clearable: "",
                      type: "textarea"
                    },
                    model: {
                      value: _vm.recForm.content,
                      callback: function($$v) {
                        _vm.$set(_vm.recForm, "content", $$v)
                      },
                      expression: "recForm.content"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "是否发布", required: "", prop: "releaseTag" }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.recForm.releaseTag,
                        callback: function($$v) {
                          _vm.$set(_vm.recForm, "releaseTag", $$v)
                        },
                        expression: "recForm.releaseTag"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 1, border: "" } }, [
                        _vm._v("是")
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0, border: "" } }, [
                        _vm._v("否")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "首页展示时间段",
                    required: "",
                    prop: "displayEndTime"
                  }
                },
                [
                  _c("el-date-picker", {
                    staticClass: "filter-item",
                    staticStyle: { width: "300px" },
                    attrs: {
                      "picker-options": _vm.pickerOptions,
                      disabled: !_vm.recForm.time,
                      clearable: "",
                      placeholder: "结束时间",
                      type: "date",
                      "value-format": "yyyy-MM-dd"
                    },
                    model: {
                      value: _vm.recForm.displayEndTime,
                      callback: function($$v) {
                        _vm.$set(_vm.recForm, "displayEndTime", $$v)
                      },
                      expression: "recForm.displayEndTime"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onSubmitRec }
                    },
                    [_vm._v(_vm._s(_vm.recForm.id ? "保存" : "新增"))]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.onDialogClose } }, [
                    _vm._v("取消")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }